<template>
  <div class="footer">
    <div class="f-container">
      <div class="row">
        <div class="col">
          <img class="footer-logo" src="@/assets/img/logo.webp" alt="" />
          <div class="desc">
            {{ t("bottom.slogan") }}
          </div>
        </div>

        <div class="col">
          <div class="online-contact" v-if="isMobile">
            <div class="label">
              <img width="24" src="@/assets/img/container2.png" alt="" />
              support@laipic.ai
            </div>
            <div class="label">
              <a
                href="https://www.youtube.com/channel/UCEXlYrC-iETysSJwq5rOwXA"
                target="_blank"
              >
                <img width="24" src="@/assets/img/container3.png" alt="" />
                {{ t("bottom.youtube") }}
              </a>
            </div>
            <div class="label">
              <a
                href="https://www.facebook.com/profile.php?id=61550910375870"
                target="_blank"
                ><img width="24" src="@/assets/img/container1.png" alt="" />
                {{ t("bottom.facebook") }}</a
              >
            </div>
          </div>
          <div class="support">
            <div class="box product">
              <div class="title">{{ t('bottom.title2') }}</div>
              <div class="label" v-for="item in product" :key="item.label">
                <a :href="user.lang==='zh'?item.zhUrl:item.url" target="_blank">{{ item.label }}</a>
              </div>
            </div>
          </div>
          <div class="online-contact" v-if="!isMobile">
            <div class="label">
              <img width="24" src="@/assets/img/container2.png" alt="" />
              support@laipic.ai
            </div>
            <div class="label">
              <a
                href="https://www.youtube.com/channel/UCEXlYrC-iETysSJwq5rOwXA"
                target="_blank"
              >
                <img width="24" src="@/assets/img/container3.png" alt="" />
                {{ t("bottom.youtube") }}
              </a>
            </div>
            <div class="label">
              <a
                href="https://www.facebook.com/profile.php?id=61550910375870"
                target="_blank"
                ><img width="24" src="@/assets/img/container1.png" alt="" />
                {{ t("bottom.facebook") }}</a
              >
            </div>
          </div>
        </div>
        <div class="col">
          <div class="box address">
            <div class="title">{{ t("bottom.title1") }}</div>
            <!-- <div class="label"> -->
            <!-- <img width="24" src="@/assets/img/address.png" alt="" /> -->
            <!-- {{ t("bottom.address") }} -->
            <!-- #14-06, 6 Raffles Quay, Singapore -->
            <!-- </div> -->
            <div class="label">
              <div class="country">{{ t('bottom.country1') }}</div>
              <div class="detail">{{ t('bottom.address1') }}</div>
              <div class="detail">{{ t('bottom.address1-1') }}</div>
            </div>
            <div class="label">
              <div class="country">{{ t("bottom.country2") }}</div>
              <div class="detail">{{ t("bottom.address2") }}</div>
            </div>
            <div class="label">
              <div class="country">{{ t("bottom.country3") }}</div>
              <div class="detail">{{ t("bottom.address3") }}</div>
            </div>
            <div class="label">
              <div class="country">{{ t("bottom.country4") }}</div>
              <div class="detail">{{ t("bottom.address4") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { reactive, watch, ref, onMounted } from 'vue';
import { useLoginStore } from '@/store';
import { scrollToHash as scrollToHashTarget } from '@/utils/scroll';
const { t } = useI18n();
import { useRoute } from "vue-router";
const isMobile = ref<boolean>(false);
const user = useLoginStore();
// const urltoads = import.meta.env.VITE_URLTOADS;
// const sdkurl = import.meta.env.VITE_CHATSDK;
const product = reactive([
  {
    label: t("bottom.product1"),
    // url: "/urltovideo",
     url: 'https://www.laipic.ai/chatsdk/editor',
    zhUrl: 'https://www.laihua.com/chatsdk/',
  },
  {
    label: t("bottom.product2"),
    url: 'https://www.doratoon.com/',
    zhUrl: 'https://www.laihua.com/',
  },
  {
    label: t("bottom.product3"),
    // url: urltoads,
    url: 'https://www.doratoon.com/openapi/en-US',
    zhUrl: 'https://www.laihua.com/openapi/zh-CN',
  },
  //   {
  //     label: t('bottom.product4'),
  //     url: sdkurl,
  //   },
  {
    label: t('bottom.product5'),
    url: 'https://www.innaio.net/',
	zhUrl: 'https://www.innaio.net/',
  },
]);

const route = useRoute();
watch(route, () => {
  scrollToHash();
});

onMounted(() => {
  const userAgent = navigator.userAgent.toLowerCase();
  // 判断是否是移动端
  if (/iphone|ipod|android|windows phone/i.test(userAgent)) {
    isMobile.value = true; // 视为移动端
  } else {
    isMobile.value = false; // 视为PC端
  }
});
function scrollToHash() {
  setTimeout(() => {
    if (route.hash) {
      scrollToHashTarget(route.hash);
    }
  }, 10);
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 584px;
  background: #fff;
  box-sizing: border-box;
  padding: 0 120px;
  padding-top: 48px;
  .f-container {
    max-width: 1680px;
    margin: 0 auto;
    position: relative;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 101px;
    height: 39px;
    background: #ffffff;
    border-radius: 1px 1px 1px 1px;
  }

  .row {
    display: flex;
    justify-content: flex-start;
  }

  .col {
    display: flex;

    &:nth-child(1) {
      display: block;
      width: 30%;
      justify-content: flex-start;
    }

    &:nth-child(2) {
      width: 24%;
      display: block;
    }

    &:nth-child(3) {
      width: 46%;
      justify-content: flex-end;
    }
    .support {
      width: 204px;
      height: 180px;
      .product {
        .label {
          font-family: Montserrat, Montserrat;
          font-weight: 400;
          font-size: 14px;
          color: #979da5;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          height: 24px;
          margin-bottom: 12px;
          a {
            font-family: Montserrat, Montserrat;
            font-weight: 400;
            font-size: 14px;
            color: #979da5;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .title {
          font-family: Montserrat, Montserrat;
          font-weight: bold;
          font-size: 16px;
          color: #475162;
          line-height: 24px;
          text-align: left;
          margin-bottom: 24px;
          font-style: normal;
          text-transform: none;
        }
      }
    }
    .online-contact {
      margin-top: 96px;
      .label {
        font-family: Montserrat, Montserrat;
        font-weight: bold;
        font-size: 16px;
        color: #475162;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 12px;
        a {
          font-family: Montserrat, Montserrat;
          font-weight: bold;
          font-size: 16px;
          color: #475162;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
      }
    }
  }

  .col {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    text-align: left;

    // .box {
    //   width: 180px;
    // }
    .footer-logo {
      width: 176px;
      height: 36px;
    }
    .desc {
      width: 306px;
      height: 80px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #979da5;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;
    }

    .title {
      font-family: Inter-Semi Bold, Inter;
      font-weight: normal;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 48px;
    }

    .label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 27px;
      height: 24px;

      img {
        margin-right: 10px;
      }

      div {
      }
    }

    a {
      font-family: Inter-Medium, Inter;
      font-weight: 500;
      font-size: 14px;
      color: #333;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      text-decoration: unset;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    a:hover {
      color: #666;
      //   text-decoration: underline;
    }

    .text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 16px;
      font-weight: 500;
    }

    .icon-box {
      margin-top: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
    .address {
      .title {
        font-family: Montserrat, Montserrat;
        font-weight: bold;
        font-size: 16px;
        color: #475162;
        line-height: 24px;
        text-align: left;
      }
      .label {
        display: block;
        margin-bottom: 24px;
        height: auto;
        .country {
          font-family: Montserrat, Montserrat;
          font-weight: 600;
          font-size: 14px;
          color: #475162;
          line-height: 24px;
          text-align: left;
          margin-bottom: 8px;
        }
        .detail {
          font-family: Montserrat, Montserrat;
          font-weight: 400;
          font-size: 14px;
          color: #979da5;
          line-height: 24px;
          text-align: left;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .footer {
    .f-container {
      max-width: 1680px;
      margin: 0 auto;
      position: relative;
    }
  }
}
@media screen and (max-width: 1780px) {
  .footer {
    .f-container {
      max-width: 1200px;
      margin: 0 auto;
      position: relative;
    }
  }
}
@media screen and (max-width: 1100px) {
  .footer {
    .f-container {
      width: 100%;
      margin: 0 auto;
      position: relative;
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: 0px;
    box-sizing: border-box;
    padding: 0 24px;

    .row {
      display: block;
      .col:nth-child(1) {
        display: block;
        width: 100%;
      }
      .col:nth-child(2) {
        display: block;
        width: 100%;
      }
      .col:nth-child(3) {
        display: block;
        width: 100%;
      }
      .desc {
        margin-top: 24px;
        width: 100%;
        height: auto;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #979da5;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .online-contact {
        margin-top: 48px;
      }
      .support {
        margin-top: 40px;
      }
      .address {
        margin-top: 40px;

        .title {
          font-family: Montserrat, Montserrat;
          font-weight: bold;
          font-size: 16px;
          color: #475162;
          line-height: 24px;
          text-align: left;
          margin-bottom: 24px;
        }
        .country {
          font-family: Montserrat, Montserrat;
          font-weight: 600;
          font-size: 14px;
          color: #475162;
          line-height: 24px;
          text-align: left;
        }
      }
    }
  }
}
@media screen and (max-width: 468px) {
  .footer {
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: 0px;
    box-sizing: border-box;
    padding: 0 16px;

    .row {
      display: block;
      .col:nth-child(1) {
        display: block;
        width: 100%;
      }
      .col:nth-child(2) {
        display: block;
        width: 100%;
      }
      .col:nth-child(3) {
        display: block;
        width: 100%;
      }
      .desc {
        margin-top: 24px;
        width: 100%;
        height: auto;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #979da5;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .online-contact {
        margin-top: 48px;
      }
      .support {
        margin-top: 40px;
      }
      .address {
        margin-top: 40px;

        .title {
          font-family: Montserrat, Montserrat;
          font-weight: bold;
          font-size: 16px;
          color: #475162;
          line-height: 24px;
          text-align: left;
          margin-bottom: 24px;
        }
        .country {
          font-family: Montserrat, Montserrat;
          font-weight: 600;
          font-size: 14px;
          color: #475162;
          line-height: 24px;
          text-align: left;
        }
      }
    }
  }
}
</style>
